import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ProjectOverviewComponent from '../../components/projects/ProjectOverviewComponent';
import { RootState } from '../../modules';
import { getProjectDetailAsync } from '../../modules/projects';
import ProjectEditDrawer from './ProjectEditDrawer';

const { kakao } = window;

interface ProjectOverviewContainerProps {
  enterpriseId: string;
  projectId: string;
}
function ProjectOverviewContainer({
  match,
}: RouteComponentProps<ProjectOverviewContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const { data, loading, error } = useSelector(
    (state: RootState) => state.projects.project,
  );
  const [visibleEditDrawer, setVisibleEditDrawer] = useState<boolean>(false);

  const dispatch = useDispatch();
  const [coords, setCoords] = useState<any>();

  useEffect(() => {
    const geocoder = new kakao.maps.services.Geocoder();
    if (data === null) return;
    geocoder.addressSearch(
      data.location,
      function (result: any[], status: any) {
        if (status === kakao.maps.services.Status.OK) {
          setCoords({ lat: result[0].y, lng: result[0].x });
        } else {
          setCoords(null);
        }
      },
    );
  }, [data]);

  useEffect(() => {
    dispatch(getProjectDetailAsync.request({ enterpriseId, projectId }));
  }, [dispatch, enterpriseId, projectId]);

  const moveToEditPage = () => {
    setVisibleEditDrawer(true);
  };

  return (
    <>
      {error && (
        <p style={{ textAlign: 'center' }}>{error.response?.data.message}</p>
      )}
      {data && (
        <Spin spinning={loading}>
          <ProjectOverviewComponent
            moveToEditPage={moveToEditPage}
            project={data}
            coords={coords}
          />
        </Spin>
      )}
      {data && (
        <ProjectEditDrawer
          visibleDrawer={visibleEditDrawer}
          enterpriseId={enterpriseId}
          projectId={projectId}
          currentProject={data}
          onClose={() => setVisibleEditDrawer(false)}
        />
      )}
    </>
  );
}

export default withRouter(ProjectOverviewContainer);
